// group ids for security groups from microsoft graph
export enum UserPermission {
    User = '86d2184a-cea5-443e-ad5b-160a37aaa5c1',
    StatusList = 'e29fbec9-c1a7-43ad-877a-a3a5571d7799',
    Emulate = '91f829e4-802a-4378-9446-a7589ae87624',
    EmulateAll = '9b561b44-f15a-4afa-a77a-380f4c3ef00f',
    CutoffDate = 'ac221457-c520-46f6-ae88-789c7bd6369e',
    ManageTimesheets = 'fe0d2945-be8f-4d35-a20a-d01fc582bb90',
    EEContractor = '3a7e5fc5-e326-4f48-bd94-93c8caa21519',
    EEProject = '0c148047-b2e9-44d0-8ec7-659a40428f2c',
    EEProjectAll = 'a0cb2f9c-d8e6-48e0-97f5-6efe0a56159d',
    ViewProject = '76e80b87-ce70-4565-b698-3150be4da4e0',
    Explanation = 'e1fc80e1-4ad6-4680-ad8c-ef297448e79c',
    ISADMIN = '07233159-7ee6-4e7e-9eec-78e631d478a8',
}

export function userPermissionFromGroupId(groupId: string) {
    if (Object.values(UserPermission).includes(groupId as UserPermission)) {
        return groupId as UserPermission
    }
    return null;
}